// extracted by mini-css-extract-plugin
export default {"container":"shapesMenu_container__qJu5T","displayContainer":"shapesMenu_displayContainer__6CIGO","item":"shapesMenu_item__VB8Lc","svg":"shapesMenu_svg__lRC26"};